import { z } from "zod";

export const SETTLEMENT_VAT_RATE = 0.16;

export function extractVat(gross: number): number {
  if (!gross || gross <= 0) return 0;
  return Math.round((gross * SETTLEMENT_VAT_RATE) / (1 + SETTLEMENT_VAT_RATE) * 100) / 100;
}

const grossAmount = z
  .string()
  .min(1, "settlement.errors.amountRequired")
  .refine((v) => !isNaN(Number(v)) && Number(v) > 0, "settlement.errors.amountPositive");

export const settleAdvanceLineSchema = z.object({
  description: z.string().optional(),
  document_no: z.string().optional(),
  document_date: z.date().nullable().optional(),
  gross_amount: grossAmount,
  has_esf: z.boolean().optional(),
});

export const settleAdvanceSchema = z.object({
  lines: z.array(settleAdvanceLineSchema),
});

export type SettleAdvanceFormValues = z.infer<typeof settleAdvanceSchema>;

export const settleTransportLineSchema = z.object({
  vendor: z.string().optional(),
  doc_no: z.string().optional(),
  date: z.date().nullable().optional(),
  amount: grossAmount,
  has_esf: z.boolean().optional(),
});

export const settleTripSchema = z.object({
  days: z.number().int().min(0, "settlement.errors.daysNegative"),
  transport: z.array(settleTransportLineSchema),
  lodging_gross: z.string().optional(),
  lodging_vendor: z.string().optional(),
  lodging_act_no: z.string().optional(),
  lodging_act_date: z.date().nullable().optional(),
  lodging_has_esf: z.boolean().optional(),
});

export type SettleTripFormValues = z.infer<typeof settleTripSchema>;
